import {
  Button,
  HStack,
  Image,
  Pressable,
  StatusBar,
  Text,
  View,
  VStack,
} from 'native-base'
import { useRef, useState } from 'react'
import { ImageBackground, Platform, useWindowDimensions } from 'react-native'
import Carousel from 'react-native-reanimated-carousel'
import { useMobileBreakpoint } from '../../../../domain/services/useBreakpoint'
import TextLink from '../../components/_shared/text/TextLink'

const Beach = require('../../assets/images/onboarding/beach.png')
const Logo = require('../../assets/images/ui/logo-cabana.png')
const Cabana = require('../../assets/images/ui/cabana.png')

const LandingScreen = ({ navigation }) => {
  const isMobile = useMobileBreakpoint()
  const { width } = useWindowDimensions()
  const [openIndex, setOpenIndex] = useState(0)
  const carouselRef = useRef(null)

  const mobile1 = require('../../assets/images/onboarding/landing-mobile-1.png')
  const mobile2 = require('../../assets/images/onboarding/landing-mobile-2.png')
  const mobile3 = require('../../assets/images/onboarding/landing-mobile-3.png')

  const desktop1 = require('../../assets/images/onboarding/landing-desktop-1.png')
  const desktop2 = require('../../assets/images/onboarding/landing-desktop-2.png')
  const desktop3 = require('../../assets/images/onboarding/landing-desktop-3.png')

  const items = isMobile
    ? [mobile1, mobile2, mobile3]
    : [desktop1, desktop2, desktop3]

  return isMobile ? (
    <ImageBackground source={Beach} resizeMode="cover">
      <VStack h={Platform.OS === 'web' ? '95vh' : '100%'} w="100%" pb="32px">
        <StatusBar barStyle="light-content" />
        <VStack
          alignItems="center"
          pt={24}
          safeAreaBottom
          flex={3}
          justifyContent="space-between">
          <VStack alignItems="center">
            <Image
              source={Logo}
              width="124px"
              height="124px"
              alt="Cabana logo"
              mb={8}
            />
            <Image source={Cabana} alt="Cabana" />
          </VStack>
          <VStack>
            <Button
              testID="create-account-button"
              w="340px"
              onPress={() => navigation.navigate('Login')}>
              Create account
            </Button>
            <View flexDirection="row" alignItems="center" w="340px">
              <View flex={1} height="1px" bg="muted.500" />
              <Text
                fontSize="16px"
                textAlign="center"
                my="16px"
                mx="24px"
                color="muted.500">
                OR
              </Text>
              <View flex={1} height="1px" bg="muted.500" />
            </View>
            <Button
              testID="log-in-button"
              w="340px"
              onPress={() => navigation.navigate('Login')}>
              Log in
            </Button>
          </VStack>
        </VStack>
      </VStack>
    </ImageBackground>
  ) : (
    <VStack h="100%" w="100%">
      <StatusBar barStyle="light-content" />
      <View flex={17}>
        <Carousel
          vertical={false}
          loop
          style={{ width: '100%' }}
          autoPlay={true}
          autoPlayInterval={2000}
          data={items}
          pagingEnabled={true}
          renderItem={({ item, index }) => (
            <Image
              alt="Carousel image beach/forest/mountain"
              key={index}
              source={item}
              defaultSource={item}
              width={width}
              flex="1"
            />
          )}
          width={width}
          onProgressChange={(_, index) => setOpenIndex(index)}
          ref={carouselRef}
        />
      </View>
      <HStack justifyContent="center" my="2" zIndex={510}>
        {items.map((item, index) => (
          <Pressable
            key={index}
            bg={openIndex === index ? 'secondary.500' : 'muted.300'}
            size="10px"
            borderRadius="full"
            mx="2"
            hitSlop={8}
            onPress={() => {
              carouselRef.current?.scrollTo({ index })
            }}
            zIndex={4000}
          />
        ))}
      </HStack>
      <VStack alignItems="center" pt={5} safeAreaBottom flex={3}>
        <Button w="340px" onPress={() => navigation.navigate('Login')}>
          Get started
        </Button>
        <Text mt="3" textAlign="center" fontWeight="medium">
          Already have an account?{' '}
          <TextLink href="Login" fontWeight="medium" hasUnderline={false}>
            Log in
          </TextLink>
        </Text>
      </VStack>
    </VStack>
  )
}

export default LandingScreen
